<template>
  <div id="app">
    <transition
      :name="pageTransitionName"
      @before-enter="handleBeforeEnter"
      @after-enter="handleAfterEnter"
    >
      <keep-alive>
        <router-view
          :key="$route.fullPath"
          v-if="$route.meta.keepAlive"
          class="app-view"
        >
        </router-view>
      </keep-alive>
    </transition>
    <transition
      :name="pageTransitionName"
      @before-enter="handleBeforeEnter"
      @after-enter="handleAfterEnter"
    >
      <router-view
        :key="$route.fullPath"
        v-if="!$route.meta.keepAlive"
        class="app-view"
      >
      </router-view>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapState('appShell', ['pageTransitionName'])
  },
  components: {},
  created() {},
  methods: {
    ...mapActions('appShell', ['setPageSwitching']),
    handleBeforeEnter(el) {
      this.setPageSwitching(true)
    },
    handleAfterEnter(el) {
      this.setPageSwitching(false)
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  .app-view {
    transition: opacity 0.1s cubic-bezier(0.55, 0, 0.1, 1);
    &.slide-left-enter-active {
      opacity: 0;
    }
    &.slide-right-enter-active {
      opacity: 0;
    }
  }
}
</style>

<style lang="scss">
@import '../src/styles/app';
</style>
